import * as actionTypes from "../actions/actionTypes";
const initialState = false;

const screenSaverReducer = (state = initialState, { type, payload } ) => {
  switch (type) {
    case actionTypes.SET_SCREENSAVER:
      return payload;

    default:
      return state;
  }
};

export default screenSaverReducer;


